import React from "react";
import { Card, CardContent, Grid, Typography } from "@mui/material";

import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";

import styles from "./BedStatus.module.scss";

const BedAtAGlance = () => {
  const { bedStatus } = useSelector((state: RootState) => state);

  return (
    <>
      <Typography
        variant="h2"
        component="h2"
        className={`${styles.headingH2} mg-b-14`}
      >
        Bed Status
      </Typography>
      <Card className={`${styles.statusCard} mg-b-24`}>
        <CardContent className="availability-card-box">
          <Grid className="align-items-center card-row" container spacing={0}>
            <Grid item xs={12} md={6}>
              <div
                className={`d-flex justify-content-between align-items-center card-column ${styles.rightBorder}`}
              >
                <Typography className="font-weight-medium">
                  Total <br />
                  Beds Available
                </Typography>
                <strong className={styles.countLg}>
                  {bedStatus.WARD.available + bedStatus.ICU.available}
                </strong>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="card-column">
                <Typography className="font-weight-medium availability-text">
                  Available in ward :{" "}
                  <strong>{bedStatus.WARD.available}</strong>
                </Typography>
                <Typography className="font-weight-medium availability-text">
                  Available in ICU : <strong>{bedStatus.ICU.available}</strong>
                </Typography>
              </div>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
};

export default BedAtAGlance;
